import React, {useEffect} from "react"
import {useSessionCookie} from "../hooks/useSessionCookie";
import {useNavigate} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {signOut} from "firebase/auth"
import {auth} from "../firebase"
import LoadingPageComponent from "../components/Loading/LoadingPageComponent"

/**
 * Sign-out stop on the guest site (linguascores.com). The session cookie is shared with
 * app.linguascores.com, but Firebase keeps a separate sign-in per site, and checkout signs people in
 * on the guest site. The app sends the browser here after its own logout to end that one too.
 */
const Logout = () => {
    const {clearUserSession} = useSessionCookie()
    const navigate = useNavigate()
    const {t} = useTranslation()

    useEffect(() => {
        signOut(auth)
            .catch(() => {})
            .finally(() => {
                clearUserSession()
                navigate("/", {replace: true})
            })
    }, [])

    return <LoadingPageComponent loadingText={t("plainLoadingText")}/>
}

export default Logout
